import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { buildSourceURL } from '../../utils/functions';
import { getSuggestedProducts, deleteSuggestedProduct } from '../../actions/product';
import SuggestedProductModal from '../../components/SuggestedProductModal/SuggestedProductModal';
import styles from './SuggestedProducts.module.css';

const SuggestedProducts = (props) => {
  const { 
    getSuggestedProducts, 
    productsData,
    deleteSuggestedProduct,
   } = props;

  const [showModal, setShowModal] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  useEffect(() => {
    getSuggestedProducts();
  }, []);

  const openModalHandler = () => {
    setInitialValue(null);
    setShowModal(true);
  };

  const editHandler = (productData) => {
    setInitialValue(productData);
    setShowModal(true);
  };

  const deleteHandler = (id) => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      deleteSuggestedProduct(id);
    }
  };
  
  const renderImage = (imageData) => {
    if (imageData.image) {
      const imageURL = imageData.image.startsWith('http')
        ? imageData.image
        : buildSourceURL(imageData.image);

      return (
        <img className={styles.dishImage} src={imageURL} />
      );
    }
  };

  return (
    <div className="wrapper">
      <SuggestedProductModal
        key={initialValue?.id + productsData.length}
        isOpen={showModal} 
        onClose={() => setShowModal(false)}
        initialValue={initialValue}
      />
      <div className={styles.tools}>
      <h1>
        Suggested Products
      </h1>
      <div className={styles.buttons}>
        <div className={styles.addDish} onClick={openModalHandler}>
          Add product
        </div>
      </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
        <tr>
          <th>Id</th>
          <th>Image</th>
          <th>Name</th>
          <th>Controls</th>
        </tr>
        </thead>
        <tbody>
        {productsData?.map((productItem) => (
          <tr key={productItem.id}>
            <td>
              {productItem.id}
            </td>
            <td>{renderImage(productItem)}</td>
            <td>
              {productItem.name}
            </td>
            <td className="controls">
              <button className="button green-button" onClick={() => editHandler(productItem)}>
                Edit
              </button>
              <button className="button red-button" onClick={() => deleteHandler(productItem.id)}>
                Delete
              </button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  productsData: store.product.suggestedProductsData,
});

const mapDispatchToProps = {
  getSuggestedProducts,
  deleteSuggestedProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuggestedProducts);